module.exports = __webpack_public_path__ + "static/img/relogio.8c00a8c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/relogio.gif
// module id = RwFL
// module chunks = 12